import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import PlayArrowIcon from "@mui/icons-material/PlayArrowOutlined";
import { QueryState } from "@/components/common/AsyncState";
import { fetchAutoRules, runAutoRules, updateAutoRule } from "@/api/notifications";

export function AutoRulesTab() {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery({ queryKey: ["auto-rules"], queryFn: fetchAutoRules });

  const toggleMutation = useMutation({
    mutationFn: ({ code, enabled }: { code: string; enabled: boolean }) => updateAutoRule(code, enabled),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ["auto-rules"] }),
  });

  const runMutation = useMutation({
    mutationFn: runAutoRules,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ["notifications", "notification-stats"] }),
  });

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" mb={2}>
        <Button variant="outlined" startIcon={<PlayArrowIcon />} disabled={runMutation.isPending} onClick={() => runMutation.mutate()}>
          Запустить автоправила сейчас
        </Button>
      </Stack>
      <QueryState isLoading={isLoading} error={error}>
        <Stack spacing={1.5}>
          {(data ?? []).map((rule) => (
            <Paper key={rule.templateCode} variant="outlined" sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="body1">{rule.templateName ?? rule.templateCode}</Typography>
              <Switch
                checked={rule.enabled}
                onChange={(e) => toggleMutation.mutate({ code: rule.templateCode, enabled: e.target.checked })}
              />
            </Paper>
          ))}
        </Stack>
      </QueryState>
    </>
  );
}
